import { TimerLockOpenOutlineIcon } from './TimerLockOpenOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 2972C8F4-C75F-4AF0-AE70-2FFEBE34461E
 * name timer-lock-open-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-lock-open-outline.svg
 * tags
 * - Date / Time 
 * - Lock 
 */
export const StopwatchLockOpenOutlineIcon = TimerLockOpenOutlineIcon;
export default StopwatchLockOpenOutlineIcon